module.exports = __webpack_public_path__ + "5fc79cf514c48996e116a3a4bc98134e.png";